import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, Typography } from 'antd';
import styled from 'styled-components';

const { Title } = Typography;

export const Login: React.FC = () => {
  const { loginWithRedirect, error } = useAuth0();

  const [redirectFailed, setRedirectFailed] = useState(false);

  useEffect(() => {
    if (!error) {
      loginWithRedirect();

      const timeout = setTimeout(() => {
        setRedirectFailed(true);
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, []);

  return (
    <Wrapper>
      <Content>
        {redirectFailed && (
          <>
            <Title>Welcome to SureSteps</Title>
            <ButtonWrapper>
              <Button onClick={() => loginWithRedirect()}>
                Proceed to login
              </Button>
            </ButtonWrapper>
          </>
        )}
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  width: 600px;
  height: 600px;
`;

const ButtonWrapper = styled.div`
  margin-top: 50px;
`;
